/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ import { blackAlpha, hcButtonFace, hcButtonText, hcCanvas, hcCanvasText, hcDisabled, hcHighlight, hcHighlightText, hcHyperlink } from "../global/colors.js";
export const generateColorTokens = ()=>({
        colorNeutralForeground1: hcCanvasText,
        colorNeutralForeground1Hover: hcHighlightText,
        colorNeutralForeground1Pressed: hcHighlightText,
        colorNeutralForeground1Selected: hcHighlightText,
        colorNeutralForeground2: hcCanvasText,
        colorNeutralForeground2Hover: hcHighlightText,
        colorNeutralForeground2Pressed: hcHighlightText,
        colorNeutralForeground2Selected: hcHighlightText,
        colorNeutralForeground2BrandHover: hcHighlightText,
        colorNeutralForeground2BrandPressed: hcHighlightText,
        colorNeutralForeground2BrandSelected: hcHighlightText,
        colorNeutralForeground3: hcCanvasText,
        colorNeutralForeground3Hover: hcHighlightText,
        colorNeutralForeground3Pressed: hcHighlightText,
        colorNeutralForeground3Selected: hcHighlightText,
        colorNeutralForeground3BrandHover: hcHighlightText,
        colorNeutralForeground3BrandPressed: hcHighlightText,
        colorNeutralForeground3BrandSelected: hcHighlightText,
        colorNeutralForeground4: hcCanvasText,
        colorNeutralForeground5: hcCanvasText,
        colorNeutralForeground5Hover: hcHighlightText,
        colorNeutralForeground5Pressed: hcHighlightText,
        colorNeutralForeground5Selected: hcHighlightText,
        colorNeutralForegroundDisabled: hcDisabled,
        colorNeutralForegroundInvertedDisabled: hcDisabled,
        colorBrandForegroundLink: hcHyperlink,
        colorBrandForegroundLinkHover: hcHyperlink,
        colorBrandForegroundLinkPressed: hcHyperlink,
        colorBrandForegroundLinkSelected: hcHyperlink,
        colorNeutralForeground2Link: hcHyperlink,
        colorNeutralForeground2LinkHover: hcHyperlink,
        colorNeutralForeground2LinkPressed: hcHyperlink,
        colorNeutralForeground2LinkSelected: hcHyperlink,
        colorCompoundBrandForeground1: hcHighlight,
        colorCompoundBrandForeground1Hover: hcHighlight,
        colorCompoundBrandForeground1Pressed: hcHighlight,
        colorBrandForeground1: hcCanvasText,
        colorBrandForeground2: hcCanvasText,
        colorBrandForeground2Hover: hcCanvasText,
        colorBrandForeground2Pressed: hcCanvasText,
        colorNeutralForeground1Static: hcCanvas,
        colorNeutralForegroundStaticInverted: hcCanvasText,
        colorNeutralForegroundInverted: hcHighlightText,
        colorNeutralForegroundInvertedHover: hcHighlightText,
        colorNeutralForegroundInvertedPressed: hcHighlightText,
        colorNeutralForegroundInvertedSelected: hcHighlightText,
        colorNeutralForegroundInverted2: hcCanvasText,
        colorNeutralForegroundOnBrand: hcButtonText,
        colorNeutralForegroundInvertedLink: hcHyperlink,
        colorNeutralForegroundInvertedLinkHover: hcHyperlink,
        colorNeutralForegroundInvertedLinkPressed: hcHyperlink,
        colorNeutralForegroundInvertedLinkSelected: hcHyperlink,
        colorBrandForegroundInverted: hcCanvasText,
        colorBrandForegroundInvertedHover: hcHighlightText,
        colorBrandForegroundInvertedPressed: hcHighlightText,
        colorBrandForegroundOnLight: hcButtonText,
        colorBrandForegroundOnLightHover: hcHighlightText,
        colorBrandForegroundOnLightPressed: hcHighlightText,
        colorBrandForegroundOnLightSelected: hcHighlightText,
        colorNeutralBackground1: hcCanvas,
        colorNeutralBackground1Hover: hcHighlight,
        colorNeutralBackground1Pressed: hcHighlight,
        colorNeutralBackground1Selected: hcHighlight,
        colorNeutralBackground2: hcCanvas,
        colorNeutralBackground2Hover: hcHighlight,
        colorNeutralBackground2Pressed: hcHighlight,
        colorNeutralBackground2Selected: hcHighlight,
        colorNeutralBackground3: hcCanvas,
        colorNeutralBackground3Hover: hcHighlight,
        colorNeutralBackground3Pressed: hcHighlight,
        colorNeutralBackground3Selected: hcHighlight,
        colorNeutralBackground4: hcCanvas,
        colorNeutralBackground4Hover: hcHighlight,
        colorNeutralBackground4Pressed: hcHighlight,
        colorNeutralBackground4Selected: hcHighlight,
        colorNeutralBackground5: hcCanvas,
        colorNeutralBackground5Hover: hcHighlight,
        colorNeutralBackground5Pressed: hcHighlight,
        colorNeutralBackground5Selected: hcHighlight,
        colorNeutralBackground6: hcCanvas,
        colorNeutralBackground7: hcCanvas,
        colorNeutralBackground7Hover: hcHighlight,
        colorNeutralBackground7Pressed: hcHighlight,
        colorNeutralBackground7Selected: hcHighlight,
        colorNeutralBackground8: hcCanvas,
        colorNeutralBackgroundInverted: hcCanvas,
        colorNeutralBackgroundInvertedHover: hcHighlight,
        colorNeutralBackgroundInvertedPressed: hcHighlight,
        colorNeutralBackgroundInvertedSelected: hcHighlight,
        colorNeutralBackgroundStatic: hcCanvas,
        colorNeutralBackgroundAlpha: hcCanvas,
        colorNeutralBackgroundAlpha2: hcCanvas,
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: hcHighlight,
        colorSubtleBackgroundPressed: hcHighlight,
        colorSubtleBackgroundSelected: hcHighlight,
        colorSubtleBackgroundLightAlphaHover: hcHighlight,
        colorSubtleBackgroundLightAlphaPressed: hcHighlight,
        colorSubtleBackgroundLightAlphaSelected: hcHighlight,
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: hcHighlight,
        colorSubtleBackgroundInvertedPressed: hcHighlight,
        colorSubtleBackgroundInvertedSelected: hcHighlight,
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: hcHighlight,
        colorTransparentBackgroundPressed: hcHighlight,
        colorTransparentBackgroundSelected: hcHighlight,
        colorNeutralBackgroundDisabled: hcCanvas,
        colorNeutralBackgroundDisabled2: hcDisabled,
        colorNeutralBackgroundInvertedDisabled: hcCanvas,
        colorNeutralStencil1: hcCanvasText,
        colorNeutralStencil2: hcCanvasText,
        colorNeutralStencil1Alpha: hcCanvasText,
        colorNeutralStencil2Alpha: hcCanvasText,
        colorBackgroundOverlay: blackAlpha[50],
        colorScrollbarOverlay: hcButtonFace,
        colorBrandBackground: hcButtonFace,
        colorBrandBackgroundHover: hcHighlight,
        colorBrandBackgroundPressed: hcHighlight,
        colorBrandBackgroundSelected: hcHighlight,
        colorCompoundBrandBackground: hcHighlight,
        colorCompoundBrandBackgroundHover: hcHighlight,
        colorCompoundBrandBackgroundPressed: hcHighlight,
        colorBrandBackgroundStatic: hcCanvas,
        colorBrandBackground2: hcCanvas,
        colorBrandBackground2Hover: hcCanvas,
        colorBrandBackground2Pressed: hcCanvas,
        colorBrandBackground3Static: hcCanvas,
        colorBrandBackground4Static: hcCanvas,
        colorBrandBackgroundInverted: hcButtonFace,
        colorBrandBackgroundInvertedHover: hcHighlight,
        colorBrandBackgroundInvertedPressed: hcHighlight,
        colorBrandBackgroundInvertedSelected: hcHighlight,
        colorNeutralCardBackground: hcCanvas,
        colorNeutralCardBackgroundHover: hcHighlight,
        colorNeutralCardBackgroundPressed: hcHighlight,
        colorNeutralCardBackgroundSelected: hcHighlight,
        colorNeutralCardBackgroundDisabled: hcCanvas,
        colorNeutralStrokeAccessible: hcCanvasText,
        colorNeutralStrokeAccessibleHover: hcHighlight,
        colorNeutralStrokeAccessiblePressed: hcHighlight,
        colorNeutralStrokeAccessibleSelected: hcHighlight,
        colorNeutralStroke1: hcCanvasText,
        colorNeutralStroke1Hover: hcHighlight,
        colorNeutralStroke1Pressed: hcHighlight,
        colorNeutralStroke1Selected: hcHighlight,
        colorNeutralStroke2: hcCanvasText,
        colorNeutralStroke3: hcCanvasText,
        colorNeutralStroke4: hcCanvasText,
        colorNeutralStroke4Hover: hcHighlight,
        colorNeutralStroke4Pressed: hcHighlight,
        colorNeutralStroke4Selected: hcHighlight,
        colorNeutralStrokeSubtle: hcCanvasText,
        colorNeutralStrokeOnBrand: hcCanvas,
        colorNeutralStrokeOnBrand2: hcCanvasText,
        colorNeutralStrokeOnBrand2Hover: hcCanvasText,
        colorNeutralStrokeOnBrand2Pressed: hcCanvasText,
        colorNeutralStrokeOnBrand2Selected: hcCanvasText,
        colorBrandStroke1: hcCanvasText,
        colorBrandStroke2: hcCanvasText,
        colorBrandStroke2Hover: hcHighlight,
        colorBrandStroke2Pressed: hcHighlight,
        colorBrandStroke2Contrast: hcCanvas,
        colorCompoundBrandStroke: hcHighlight,
        colorCompoundBrandStrokeHover: hcHighlight,
        colorCompoundBrandStrokePressed: hcHighlight,
        colorNeutralStrokeDisabled: hcDisabled,
        colorNeutralStrokeDisabled2: hcDisabled,
        colorNeutralStrokeInvertedDisabled: hcDisabled,
        colorTransparentStroke: hcCanvasText,
        colorTransparentStrokeInteractive: hcHighlight,
        colorTransparentStrokeDisabled: hcDisabled,
        colorNeutralStrokeAlpha: hcCanvasText,
        colorNeutralStrokeAlpha2: hcCanvas,
        colorStrokeFocus1: hcCanvas,
        colorStrokeFocus2: hcHighlight,
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.24)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.28)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.40)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.48)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });
